module.exports = __webpack_public_path__ + "static/media/desarrollo8.63efdd03.png";